import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { UserContext } from "../UserContext";
import Header from "../Header";
import PackDetails from "../PackDetails";
import ConfirmModal from "./ConfirmModal";
import ChangeBasePlanModal from "./ChangeBasePlanModal";
import ComboPlansModal from "./ComboPlansModal";
import PlanCard from "./PlanCard";
import { ToastContainer, toast, Zoom } from "react-toastify";
import "./index.css";

const CustomerV2 = () => {
  const { id } = useParams();
  const { user, token } = useContext(UserContext);
  const role = user.role;

  const [customer, setCustomer] = useState(null);
  const [operator, setOperator] = useState(null);
  const [operators, setOperators] = useState([]);
  const [basePlan, setBasePlan] = useState(null);
  const [addons, setAddons] = useState([]);
  const [allPackDetails, setAllPackDetails] = useState([]);
  const [mappedAddons, setMappedAddons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [devices, setDevices] = useState([]);
  const [deviceType, setDeviceType] = useState("normal");
  const [stelfiberDevices, setStelfiberDevices] = useState([]);
  const [devicesModalVisible, setDevicesModalVisible] = useState(false);
  const [selectedUserForDevices, setSelectedUserForDevices] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [assignDevices,setAssignDevices] = useState([]);
  const [showAssign,setShowAssign] = useState(false);

  const [assignLoading, setAssignLoading] = useState(false);
  const [assignSearch, setAssignSearch] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showUsernamePassword, setShowUsernamePassword] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);
  const [renewCooldown, setRenewCooldown] = useState({});
  const [comboModal, setComboModal] = useState(false);

  const [allowedPlans, setAllowedPlans] = useState({
    ottplay1: [],
    ottplay2: [],
    watcho: [],
    playboxtv: [],
    antiptv: []
});

  const [confirmModal, setConfirmModal] = useState({
    open: false,
    type: null
  });

  const [expiryData, setExpiryData] = useState({
    vrplay: null,
    ottplay1: null,
    ottplay2: null,
    watcho: null,
    playboxtv: null,
    antiptv: null
  });

  const [expiryLoading, setExpiryLoading] = useState(false);
  
  const [editForm, setEditForm] = useState({
    username: '',
    password: '',
    name: '',
    lastName: '',
    MobileNumber: '',
    EmailId: '',
    address: '',
    operatorDetails:
      role === "operator"
        ? `${user.operatorName || ''} - ${user.phoneNumber || ''}`
        : role === "admin"
        ? `${user.operatorName || ''} - ${user.operatorPhoneNumber || ''}`
        : "",  // superadmin chooses later
    autoplay: 'on',
    operatorId:
      role === "operator"
        ? user.operatorId
        : role === "admin"
        ? user.operatorId
        : "",
    remarks: ''
  });

  const [plansData, setPlansData] = useState({
    vrplay: null,
    ottplay1: null,
    ottplay2: null,
    watcho: null,
    playboxtv: null,
    antiptv: null
  });

  useEffect(() => {
    if (!customer || allPackDetails.length === 0) return;

    const vrplay = allPackDetails.find(
      p => Number(p.id) === Number(customer.vrplay_planId)
    );

    const ottplay1 = allPackDetails.find(
      p => Number(p.id) === Number(customer.ottplay_planId)
    );

    const ottplay2 = allPackDetails.find(
      p => Number(p.id) === Number(customer.ottplay_planId2)
    );

    const watcho = allPackDetails.find(
      p => Number(p.id) === Number(customer.watcho_planId)
    );

    const playboxtv = allPackDetails.find(
      p => Number(p.id) === Number(customer.playboxtv_planId)
    );

    const antiptv = allPackDetails.find(
      p => Number(p.id) === Number(customer.antiptv_planId)
    );


    setPlansData({
      vrplay: vrplay || null,
      ottplay1: ottplay1 || null,
      ottplay2: ottplay2 || null,
      watcho: watcho || null,
      playboxtv: playboxtv || null,
      antiptv: antiptv || null
    });

  }, [customer, allPackDetails]);

  
  const fetchCustomer = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `https://vrplay.in/portal_php/customer/get_customer_full_details.php?id=${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const data = await res.json();

      if (!res.ok) throw new Error(data.error || "Failed");

      setCustomer(data.customer);
      setBasePlan(data.base_plan);
      setAddons(data.addons || []);
    } catch (err) {
      setError(err.message);
      toast.error("Failed to load customer");
    } finally {
      setLoading(false);
    }
  };

  const fetchOperator = async () => {
    if (!customer?.operatorId) return;

    try {
      const res = await fetch(
        `https://vrplay.in/portal_php/operator_api.php?id=${customer.operatorId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const data = await res.json();
      setOperator(data.operator);
    } catch {
      toast.error("Failed to load operator");
    }
  };
  
  const fetchOperators = async () => {
    try {
      const response = await fetch(`https://vrplay.in/portal_php/operator_api.php`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();        
      if (response.ok) {
        setOperators(data.operators);
        setError(null);
      } else {
        setError(data.error || 'Failed to fetch operators');
      }
    } catch (err) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (role !== "operator") {
      fetchOperators();
    }
  }, [role]);

  const fetchAllPackages = async () => {
    try {
      const res = await fetch(
        "https://vrplay.in/portal_php/get_operator_allplans_with_apps.php",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const data = await res.json();
      setAllPackDetails(data || []);
    } catch {
      toast.error("Failed to load plans");
    }
  };

  useEffect(() => {
    fetchCustomer();
    fetchAllPackages();
  }, []);

  useEffect(() => {
    if (customer) fetchOperator();
  }, [customer]);


  useEffect(() => {
    if (addons.length > 0 && allPackDetails.length > 0) {
      const mapped = addons.map((addon) => {
        const full = allPackDetails.find(
          (p) => Number(p.id) === Number(addon.plan_id)
        );

        return {
          ...(full || {}),
          ...addon,
        };
      });

      setMappedAddons(mapped);
    }
  }, [addons, allPackDetails]);

  const syncPlans = async () => {
    if (!customer?.id) return;

    setExpiryLoading(true);

    const res = await fetch(
        `https://vrplay.in/portal_php/customer/sync_user_plans.php?user_id=${customer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

    const text = await res.text();

    try {
      const data = JSON.parse(text);
      // console.log(data);
      
      if (data.success) {
        setExpiryData({
          vrplay: data.data.vrplay_expiry,
          ottplay1: data.data.ottplay_expiry1,
          ottplay2: data.data.ottplay_expiry2,
          watcho: data.data.watcho_expiry,
          playboxtv: data.data.playboxtv_expiry,
          antiptv: data.data.antiptv_expiry
        });
      } else {
        toast.error("Failed to sync plans");
      }

    } catch (e) {
      console.error("INVALID JSON:", text);
      toast.error("Server returned invalid response");
    } finally {
      setExpiryLoading(false);
    }
  };
  
  useEffect(() => {
    if (customer?.id) {
      syncPlans();
    }
  }, [customer]);

  const getFinalOttExpiry = () => {
    return expiryData.ottplay2 || expiryData.ottplay1;
  };

  const isExpired = (date) => {
    if (!date) return false;
    return new Date(date) < new Date();
  };

  const openEditCustomerForm = (cust) => {
    setEditForm({
      id: cust.id,
      username: cust.username,
      password: cust.password,
      name: cust.name,
      lastName: cust.lastName,
      MobileNumber: cust.MobileNumber,
      EmailId: cust.EmailId,
      address: cust.address,
      ExpiryDate: cust.ExpiryDate,
      maximumDevices: cust.maximumDevices,
      operatorDetails: cust.operatorDetails,
      operatorId: cust.operatorId,
      autoplay: cust.autoplay,
      remarks: cust.remarks
    });
    setShowEditForm(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;

    if (name === "operatorId") {
      const selectedOperator = operators.find(o => String(o.id) === String(value));

      setEditForm(prev => ({
        ...prev,
        operatorId: value,
        operatorDetails: selectedOperator
          ? `${selectedOperator.operatorName} - ${selectedOperator.phoneNumber}`
          : ""
      }));
    } else {
      setEditForm(prev => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = () => {
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!editForm.name.trim()) {
      toast.error("Name is required");
      return false;
    } else if (!nameRegex.test(editForm.name.trim())) {
      toast.error("Name can only contain letters and spaces");
      return false;
    }

    if (!editForm.lastName.trim()) {
      toast.error("Last Name is required");
      return false;
    } else if (!nameRegex.test(editForm.lastName.trim())) {
      toast.error("Last Name can only contain letters and spaces");
      return false;
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(editForm.MobileNumber)) {
      toast.error("Please enter a valid 10-digit phone number.");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (editForm.EmailId && !emailRegex.test(editForm.EmailId)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    return true;
  };

  const submitEditForm = async () => {    
    if (!validateForm()) return;
    setLoading(true);
    try {
      await axios.put('https://vrplay.in/portal_php/allCustomers.php', editForm, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success('Customer updated successfully!');
      setShowEditForm(false);
      fetchCustomer()
    } catch (err) {
      toast.error('Failed to update Customer');
    } finally {
      setLoading(false);
    }
  };

  const isActive = (date) => new Date(date) >= new Date();

  const handleRenew = (type) => {
    setConfirmModal({ open: true, type });
  };

  const confirmRecharge = async () => {
  const type = confirmModal.type;
  setConfirmModal({ open: false, type: null });

  setActionLoading(type);

  try {
    if (type === "vrplay") {
      await rechargeVrplay(customer.vrplay_planId);
    }

    if (type === "ottplay1") {
      // if (!plansData.ottplay1) {
      //   toast.error("No OTT plan selected");
      //   return;
      // }
      // await rechargeOttPlan(plansData.ottplay1, "1");
    }

    if (type === "ottplay2") {
      // if (!plansData.ottplay2) {
      //   toast.error("No OTT plan selected");
      //   return;
      // }
      // await rechargeOttPlan(plansData.ottplay2, "2");
    }

    if (type === "watcho") {
      await rechargeWatchoPlan(customer.watcho_planId);
    }

    if (type === "playboxtv") {
      await rechargePlayboxtvPlan(customer.playboxtv_planId);
    }

    if (type === "antiptv") {
      await rechargeAntiptvPlan(customer.antiptv_planId);
    }

  } finally {
    setActionLoading(null);
  }
};

  const rechargeVrplay = async (planId) => {
    if (!window.confirm("Are you sure you want to recharge VRPLAY plan?")) return;

    try {
      const res = await fetch(
        "https://vrplay.in/portal_php/customer/recharge_vrplay.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            user_id: customer.id,
            plan_id: planId
          })
        }
      );

      const data = await res.json();

      if (data.success) {
        toast.success("VRPLAY recharged");
        triggerCooldown("vrplay");
        syncPlans(); // refresh expiry
      } else {
        toast.error(data.error || "Failed");
      }

    } catch {
      toast.error("Server error");
    }
  };

  const rechargeOttPlan = async (plan, slot) => {
    if (!window.confirm(`Are you sure you want to recharge ${plan.planName} on slot ${slot}?`)) return;
    try {
      const res = await fetch(
        "https://vrplay.in/portal_php/customer/recharge_ottplay.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            user_id: customer.id,
            plan_id: plan.id,
            plan_slot: slot,
          }),
        }
      );
      const text = await res.text();
      // console.log(text);

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("INVALID JSON:", text);
        throw new Error("Invalid JSON");
      }

      if (data.success) {
        toast.success("Recharge successful ✅");
        fetchCustomer();   // ✅ refresh plans
        syncPlans();       // ✅ refresh expiry

      } else {
        toast.error(data.error || "Recharge failed");
      }

    } catch (err) {
      console.error(err);
      toast.error("Server error");
    }
  };

  const rechargeWatchoPlan = async (planId) => {
    if (!window.confirm("Are you sure you want to recharge Watcho plan?")) return;
    try {
      const res = await fetch(
        "https://vrplay.in/portal_php/customer/recharge_watcho.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            user_id: customer.id,
            plan_id: planId
          })
        }
      );

      // 🔥 IMPORTANT: read only once
      const text = await res.text();
      // console.log(text);
      
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("INVALID JSON:", text);
        toast.error("Server returned invalid response");
        return;
      }

      // console.log("WATCHO RESPONSE:", data);

      // ❌ API FAILED
      if (!res.ok || !data.success) {
        // console.error("Watcho recharge failed:", data);

        toast.error(data.error || "Recharge failed");

        // optional debug
        if (data.watcho_response) {
          // console.log("WATCHO DEBUG:", data.watcho_response);
        }

        return;
      }

      // ✅ SUCCESS
      toast.success("Watcho plan recharged successfully");
      triggerCooldown("watcho");

      // 🔄 Update wallet UI
      if (data.wallet !== undefined) {
        setOperator(prev => ({
          ...prev,
          wallet: data.wallet
        }));
      }

      // 🔄 Refresh expiry
      syncPlans(); // your existing function

      // 🔄 Refresh customer data
      fetchCustomer(); 

    } catch (err) {
      console.error("Watcho API error:", err);
      toast.error("Server error during recharge");
    }
  };

  const rechargePlayboxtvPlan = async (planId) => {
    if (!window.confirm("Are you sure you want to recharge PlayBox TV plan?")) return;

    try {
      const res = await fetch(
        "https://vrplay.in/portal_php/customer/recharge_playboxtv.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            user_id: customer.id,
            plan_id: planId
          })
        }
      );

      // 🔥 IMPORTANT: read response safely
      const text = await res.text();
      // console.log("PLAYBOX RAW:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("INVALID JSON:", text);
        toast.error("Server returned invalid response");
        return;
      }

      // console.log("PLAYBOX RESPONSE:", data);

      // ❌ API FAILED
      if (!res.ok || !data.success) {
        console.error("PlayBox recharge failed:", data);

        toast.error(data.error || "Recharge failed");

        if (data.playboxtv_response) {
          // console.log("PLAYBOX DEBUG:", data.playboxtv_response);
        }

        return;
      }

      // ✅ SUCCESS
      toast.success("PlayBox TV plan recharged successfully");
      triggerCooldown("playboxtv");

      // 🔄 Update wallet UI (same as Watcho)
      if (data.wallet !== undefined) {
        setOperator(prev => ({
          ...prev,
          wallet: data.wallet
        }));
      }

      // 🔄 Refresh expiry
      syncPlans();

      // 🔄 Refresh customer data
      fetchCustomer();

    } catch (err) {
      console.error("PlayBox API error:", err);
      toast.error("Server error during recharge");
    }
  };

  const rechargeAntiptvPlan = async (planId) => {
    if (!window.confirm("Are you sure you want to recharge ANT IPTV plan?")) return;

    try {
      const res = await fetch(
        "https://vrplay.in/portal_php/customer/recharge_antiptv.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            user_id: customer.id,
            plan_id: planId
          })
        }
      );

      const text = await res.text();

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("INVALID JSON:", text);
        toast.error("Server returned invalid response");
        return;
      }

      // ❌ API FAILED
      if (!res.ok || !data.success) {
        toast.error(data.error || "Recharge failed");
        return;
      }

      // ✅ GET PROVIDER MESSAGE
      const providerMsg =
        data?.antiptv_response?.message || "Recharge successful";

      // normalize message (remove line breaks/spaces)
      const cleanMsg = providerMsg.replace(/\s+/g, " ").trim();

      // 🎯 SMART TOAST
      if (cleanMsg.includes("Pre Renewed")) {
        toast.success("Advance Renewal successful ✅");
      } else if (cleanMsg.includes("Renewed")) {
        toast.success("Recharge successful ✅");
      } else if (cleanMsg.includes("Created")) {
        toast.success("Plan Activated successfully ✅");
      } else {
        toast.success(cleanMsg);
      }

      // 💰 UPDATE WALLET (if returned)
      if (data.wallet !== undefined) {
        setOperator(prev => ({
          ...prev,
          wallet: data.wallet
        }));
      }

      // 🔄 REFRESH DATA
      syncPlans();
      fetchCustomer();

    } catch (err) {
      console.error("ANT IPTV error:", err);
      toast.error("Server error during recharge");
    }
  };

  const [planModal, setPlanModal] = useState({
    visible: false,
    type: null,
    slot: "1"   // ✅ default
  });

  const handleChange = async (type, slot = "1") => {

    // 🔥 FETCH BASED ON CURRENT USER STATE
    if (type === "ottplay" && slot === "2" && plansData.ottplay1) {
      // await fetchComboOptions({ ott1: plansData.ottplay1.id });
    }

    if (type === "watcho" && plansData.ottplay1) {
      await fetchComboOptions({ ott1: plansData.ottplay1.id });
    }
    
    if (type === "ottplay" && slot === "1" && plansData.watcho) {
      // await fetchComboOptions({ watcho: plansData.watcho.id });
    }

    if (type === "playboxtv" && slot === "1" && plansData.playboxtv) {
      await fetchComboOptions({ playboxtv: plansData.playboxtv.id });
    }

    if (type === "antiptv" && slot === "1" && plansData.antiptv) {
      await fetchComboOptions({ antiptv: plansData.antiptv.id });
    }

    setActionLoading(type + slot);

    setPlanModal({
      visible: true,
      type,
      slot
    });

    setTimeout(() => setActionLoading(null), 300);
  };

  const getDevices = async () => {
    setDeviceType("normal");
    setSelectedUserForDevices(customer); // ✅ ADD THIS
    setDevicesModalVisible(true);

    try {
      const res = await fetch(
        `https://vrplay.in/portal_php/get_user_devices.php?user_id=${customer.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const data = await res.json();
      setDevices(data.devices || []);
    } catch {
      toast.error("Failed to load devices");
    }
  };

  const removeDevice = async (userId, deviceId) => {
      if (!window.confirm('Are you sure you want to remove this device?')) return;
      try {
        const response = await fetch("https://vrplay.in/portal_php/remove_customer_device.php", { 
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ user_id: userId, device_id: deviceId }),
        });
  
        const data = await response.json();
  
        if (data.success) {
          toast.success('Device removed successfully!');
          getDevices(customer.id);
        } else {
          toast.error('Failed to remove device: ' + data.message);
        }
      } catch (error) {
        toast.warn('An error occurred while removing the device.');
      }
    };
  
    const getStelfiberDevices = async (id) => { 
      setDeviceType("stelfiber");
      setSelectedUserForDevices(customer);
      setDevicesModalVisible(true);
      try {
        const response = await fetch(`https://vrplay.in/portal_php/get_user_stelfiber_devices.php?user_id=${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error('Failed to fetch devices');
        const data = await response.json();
        if (data.success && Array.isArray(data.devices)) {
            setStelfiberDevices(data.devices);
        } else {
            setStelfiberDevices([]);
        }
      } catch (error) {
        setStelfiberDevices([]);
      }
    };
  
    const removeStelfiberDevice = async (userId, deviceId) => {
      if (!window.confirm('Are you sure you want to remove this device?')) return;
      try {
        const response = await fetch("https://vrplay.in/portal_php/remove_customer_stelfiber_device.php", { 
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ user_id: userId, device_id: deviceId }),
        });
  
        const data = await response.json();
  
        if (data.success) {
          toast.success('Device removed successfully!');
          getStelfiberDevices(customer.id);
        } else {
          toast.error('Failed to remove device: ' + data.message);
        }
      } catch (error) {
        toast.warn('An error occurred while removing the device.');
      }
    };
  
    const fetchAssignableStelfiber = async () => {
      if(customer.loginDevices >= customer.maximumDevices){
        toast.error("Device limit reached");
        return;
      }
  
      setAssignLoading(true);
  
      try {
        const res = await fetch(
          `https://vrplay.in/portal_php/get_operator_stelfiber_devices.php?user_id=${customer.id}`,
          { headers:{ Authorization:`Bearer ${token}` } }
        );
  
        const data = await res.json();
  
        if(data.success){
          setAssignDevices(data.devices);
          setShowAssign(true);
        } else {
          toast.error(data.message);
        }
      } catch {
        toast.error("Network error");
      } finally {
        setAssignLoading(false);
      }
    };
  
    const assignStelfiberDevice = async(deviceId)=>{
      if(!window.confirm("Assign this device?")) return;
      setAssignLoading(true);
      try {
        const res = await fetch("https://vrplay.in/portal_php/assign_stelfiber_device.php",{
          method:"POST",
          headers:{
            "Content-Type":"application/json",
            Authorization:`Bearer ${token}`
          },
          body:JSON.stringify({
            device_id:deviceId,
            user_id:customer.id
          })
        });
  
        const data = await res.json();
  
        if(data.success){
          toast.success("Device Assigned");
          setAssignSearch(""); 
          setShowAssign(false);
          setDevicesModalVisible(false);
          getStelfiberDevices(customer.id);
        } else {
          toast.error(data.message);
        }
      } finally {
        setAssignLoading(false);
      }
    };
  
    const handleResetDevicesCount = async (userId) => {
      if (!window.confirm("Are you sure you want to reset all devices for this user?")) return;
  
      try {
        const response = await fetch("https://vrplay.in/portal_php/reset_customer_devicecount.php", { 
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ user_id: userId }),
        });
  
        const data = await response.json();
        if (data.success) {
          toast.success("Device count reset successfully!");
          fetchCustomer();
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        toast.warn("An error occurred while resetting the device count.");
      }
    };

    const triggerCooldown = (type, minutes = 5) => {
      const expiryTime = Date.now() + minutes * 60 * 1000;

      const updated = {
        ...renewCooldown,
        [type]: expiryTime
      };

      setRenewCooldown(updated);
      localStorage.setItem(`renewCooldown_${id}`, JSON.stringify(updated));
    };

    useEffect(() => {
      const stored = localStorage.getItem(`renewCooldown_${id}`);
      if (stored) {
        setRenewCooldown(JSON.parse(stored));
      }
    }, []);

    useEffect(() => {
      const interval = setInterval(() => {
        setRenewCooldown(prev => ({ ...prev }));
      }, 1000);

      return () => clearInterval(interval);
    }, []);

    const isCooldownActive = (type) => {
      const expiry = Number(renewCooldown[type]);
      return expiry && Date.now() < expiry;
    };

    const getRemainingTime = (type) => {
      const expiry = Number(renewCooldown[type]);
      if (!expiry) return null;

      const diff = expiry - Date.now();
      if (diff <= 0) return null;

      const min = Math.floor(diff / 60000);
      const sec = Math.floor((diff % 60000) / 1000);

      return `${min}m ${sec}s`;
    };

    const isActivePlan = (expiry) => {
      if (!expiry) return false;

      const today = new Date();
      const exp = new Date(expiry);

      today.setHours(0,0,0,0);
      exp.setHours(0,0,0,0);

      return exp >= today;
    };

  const fetchComboOptions = async (filters) => {
    try {
      const params = new URLSearchParams(filters).toString();

      const res = await fetch(
        `https://vrplay.in/portal_php/customer/get_operator_plans.php?${params}`
      );

      const data = await res.json();

      if (data.success) {
        setAllowedPlans({
          ottplay1: data.data.ottplay_plan1,
          ottplay2: data.data.ottplay_plan2,
          watcho: data.data.watcho
        });
      }
    } catch (err) {
      console.error("Combo fetch error", err);
    }
  };

  const showComboButton = 
    !isActivePlan(expiryData?.playboxtv) &&
    !isActivePlan(expiryData?.watcho);

  return (
    <>
      <Header />

      <div className="customer-page">
        <ToastContainer transition={Zoom} theme="colored" />

        {loading ? (
          <div className="customer-loading-container">
            <div className="customer-skeleton-card">
              {/* Header Skeleton */}
              <div className="skeleton-header">
                <div className="skeleton-title"></div>
              </div>
              
              {/* Customer Details Skeleton */}
              <div className="skeleton-details">
                {[...Array(8)].map((_, index) => (
                  <div key={index} className="skeleton-detail-row">
                    <div className="skeleton-label"></div>
                    <div className="skeleton-value"></div>
                  </div>
                ))}
              </div>
              
              {/* Package Skeleton */}
              <div className="skeleton-package-section">
                <div className="skeleton-package-header">
                  <div className="skeleton-package-title"></div>
                </div>
                <div className="skeleton-package-details">
                  <div className="skeleton-package-row">
                    <div className="skeleton-package-label"></div>
                    <div className="skeleton-package-value"></div>
                  </div>
                  <div className="skeleton-package-row">
                    <div className="skeleton-package-label"></div>
                    <div className="skeleton-package-value"></div>
                  </div>
                </div>
                <div className="skeleton-ott-container">
                  {[...Array(4)].map((_, index) => (
                    <div key={index} className="skeleton-ott-item"></div>
                  ))}
                </div>
              </div>
              
              {/* Action Buttons Skeleton */}
              <div className="skeleton-actions">
                <div className="skeleton-button-group">
                  <div className="skeleton-button"></div>
                  <div className="skeleton-button"></div>
                </div>
                <div className="skeleton-button-group">
                  <div className="skeleton-button"></div>
                  <div className="skeleton-button"></div>
                </div>
              </div>
            </div>
          </div>
        ) : error ? (
          <p className="error">{error}</p>
        ) : (
          <div className="customer-container">

            {/* CUSTOMER DETAILS CARD */}
            {customer && (
              <div className="customer-profile-card">
                <div className="profile-card-header">
                  <div className="profile-avatar">
                    <div className="avatar-initials">
                      {customer.name?.charAt(0)}{customer.lastName?.charAt(0)}
                    </div>
                  </div>
                  <div className="profile-title">
                    <h2>{customer.name} {customer.lastName}</h2>
                    <span className={`status-badge ${isActive(customer.ExpiryDate) ? 'status-active' : 'status-expired'}`}>
                      {isActive(customer.ExpiryDate) ? 'Active' : 'Expired'}
                    </span>
                  </div>
                  <button 
                    className="btn-edit-profile" 
                    onClick={() => openEditCustomerForm(customer)}
                  >
                    ✏️ Edit Profile
                  </button>
                </div>
                
                <div className="profile-details-grid">
                  <div className="detail-item">
                    <div className="detail-icon">📞</div>
                    <div className="detail-info">
                      <label>Phone Number:</label>
                      <p>{customer.MobileNumber}</p>
                    </div>
                  </div>

                  <div className="detail-item">
                    <div className="detail-icon">🔑</div>
                    <div className="detail-info">
                      <label>Password</label>
                      <div className="password-field">
                        <span className="password-value">
                          {showUsernamePassword ? customer.password : "••••••••••"}
                        </span>
                        <button
                          className="password-toggle-btn"
                          onClick={() => setShowUsernamePassword(!showUsernamePassword)}
                          title={showUsernamePassword ? "Hide password" : "Show password"}
                        >
                          {showUsernamePassword ? "🙈" : "👁️"}
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div className="detail-item">
                    <div className="detail-icon">📧</div>
                    <div className="detail-info">
                      <label>Email Address:</label>
                      <p>{customer.EmailId || 'Not provided'}</p>
                    </div>
                  </div>
                  
                  <div className="detail-item">
                    <div className="detail-icon">🏢</div>
                    <div className="detail-info">
                      <label>Operator:</label>
                      <p>{customer.operatorDetails}</p>
                    </div>
                  </div>
                  
                  <div className="detail-item">
                    <div className="detail-icon">📅</div>
                    <div className="detail-info">
                      <label>Expiry Date:</label>
                      <p>{customer.ExpiryDate}</p>
                    </div>
                  </div>
                  
                  <div className="detail-item">
                    <div className="detail-icon">💳</div>
                    <div className="detail-info">
                      <label>Devices:</label>
                      <p>{customer.loginDevices}/{customer.maximumDevices}</p>
                    </div>
                  </div>
                  
                  {/* <div className="detail-item">
                    <div className="detail-icon">🎬</div>
                    <div className="detail-info">
                      <label>Autoplay</label>
                      <p className="autoplay-status">
                        {customer.autoplay === 'on' ? 'Enabled' : 'Disabled'}
                      </p>
                    </div>
                  </div> */}
                </div>
                
                {customer.address && (
                  <div className="profile-address">
                    <div className="address-icon">📍</div>
                    <div className="address-info">
                      <label>Address:</label>
                      <p>{customer.address}</p>
                    </div>
                  </div>
                )}
                
                {customer.remarks && (
                  <div className="profile-remarks">
                    <div className="remarks-icon">📝</div>
                    <div className="remarks-info">
                      <label>Remarks:</label>
                      <p>{customer.remarks}</p>
                    </div>
                  </div>
                )}
              </div>
            )}

            <div className="section">
            <div className="section-header">
              <h3>📦 Plans</h3>
              <button 
                className="btn-combo"
                onClick={() => setComboModal(true)}
                disabled={!showComboButton}
              >
                Plans Suggestion
              </button>
            </div>

            <div className="plans-container">
              <h2 className="plan-title title-vrplay">VRPLAY</h2>
              <PlanCard
                title="VRPlay"
                type="vrplay"
                data={plansData.vrplay}
                expiry={expiryData.vrplay}
                onRenew={() => handleRenew("vrplay")}
                onChange={() => handleChange("vrplay")}
                onDevices={getDevices}
                onStelfiberDevices={getStelfiberDevices}
                loading={actionLoading === "vrplay"}
                cooldownActive={isCooldownActive("vrplay")}
                remainingTime={getRemainingTime("vrplay")}
              />

              <h2 className="plan-title title-watcho">WATCHO</h2>
              <PlanCard
                title="Watcho"
                type="watcho"
                data={plansData.watcho}
                expiry={expiryData.watcho}
                onRenew={() => handleRenew("watcho")}
                onChange={() => handleChange("watcho")}
                loading={actionLoading === "watcho"}
                cooldownActive={isCooldownActive("watcho")}
                remainingTime={getRemainingTime("watcho")}
              />

              <div className="playbox-ott-section">
                <h2 className="plan-title title-playboxtv">PLAYBOX TV</h2>
                <h3 className="playbox-note-text">(Please Note: Playbox TV app is not available in Samsung and LG TV's)</h3>
              </div>
              <PlanCard
                title="Playbox TV"
                type="playboxtv"
                data={plansData.playboxtv}
                expiry={expiryData.playboxtv}
                onRenew={() => handleRenew("playboxtv")}
                onChange={() => handleChange("playboxtv")}
                loading={actionLoading === "playboxtv"}
                cooldownActive={isCooldownActive("playboxtv")}
                remainingTime={getRemainingTime("playboxtv")}
              />

              <div className="playbox-ott-section">
                <h2 className="plan-title title-playboxtv">ANT IPTV</h2>
                <h3 className="playbox-note-text">(Please Note: ANT IPTV app is not available in Samsung and LG TV's (Coming Soon))</h3>
              </div>
              <PlanCard
                title="ANT IPTV"
                type="antiptv"
                data={plansData.antiptv}
                expiry={expiryData.antiptv}
                onRenew={() => handleRenew("antiptv")}
                onChange={() => handleChange("antiptv")}
                loading={actionLoading === "antiptv"}
                cooldownActive={isCooldownActive("antiptv")}
                remainingTime={getRemainingTime("antiptv")}
              />

              {plansData.ottplay1 && isActivePlan(expiryData.ottplay1) && (
                <>
                  <h2 className="plan-title title-ottplay">OTTPLAY</h2>

                  <PlanCard
                    title="OTTPlay - Slot 1"
                    type="ottplay"
                    data={plansData.ottplay1}
                    expiry={expiryData.ottplay1}
                    onRenew={null}
                    onChange={null}
                    disableActions={true}
                  />
                </>
              )}
            </div>
          </div>
          </div>
        )}
      </div>

      <ComboPlansModal
        visible={comboModal}
        onClose={() => setComboModal(false)}
        token={token}
        allPlans={allPackDetails}
        userId={customer?.id}
        onSuccess={fetchCustomer}
      />

      <ChangeBasePlanModal
        visible={planModal.visible}
        onClose={() => setPlanModal({ visible: false, type: null })}
        userId={customer?.id}
        type={planModal.type}
        currentPlanId={
          planModal.type === "vrplay"
            ? customer?.vrplay_planId
            : planModal.type === "playboxtv"
            ? customer?.playboxtv_planId
            : planModal.type === "antiptv"
            ? customer?.antiptv_planId
            : customer?.watcho_planId
        }
        slot={planModal.slot}
        token={token}
        onSuccess={fetchCustomer}
        allowedPlans={allowedPlans}
        fetchComboOptions={fetchComboOptions}
      />

    <ConfirmModal
      isOpen={confirmModal.open}
      message="Once recharge is successful, it cannot be cancelled or reverted. Please confirm before proceeding."
      onConfirm={confirmRecharge}
      onCancel={() => setConfirmModal({ open: false, type: null })}
    />
      
    {devicesModalVisible && (
      <DevicesModal
        user={selectedUserForDevices}
        devices={deviceType === "normal" ? devices : stelfiberDevices}
        deviceType={deviceType}
        assignLoading={assignLoading}
        onClose={() => setDevicesModalVisible(false)}
        removeDevice={deviceType === "normal" ? removeDevice : removeStelfiberDevice}
        handleResetDevicesCount={deviceType === "normal" ? handleResetDevicesCount : null}
        fetchAssignableStelfiber={fetchAssignableStelfiber}
        assignDevices={assignDevices}
        showAssign={showAssign}
        setShowAssign={setShowAssign}
        assignSearch={assignSearch}
        setAssignSearch={setAssignSearch}
        assignStelfiberDevice={assignStelfiberDevice}
        assignDevicesLoading={assignLoading}
      />
    )}

      {showEditForm && (
        <div className="modal-overlay">
          <div className="modal-content edit-modal">
            <div className="modal-header">
              <h3>Edit Customer</h3>
              <button className="close-modal" onClick={() => setShowEditForm(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                {role === "superadmin" && (
                  <div className="form-group">
                    <label>Username</label>
                    <input name="username" placeholder="Username" value={editForm.username} onChange={handleEditChange} />
                  </div>
                )}
                <div className="form-group">
                  <label>Password</label>
                  <div className="password-wrapper">
                    <input 
                      name="password" 
                      type={showPassword ? "text" : "password"} 
                      placeholder="New Password" 
                      value={editForm.password} 
                      onChange={handleEditChange} 
                    />
                    <span 
                      className="password-toggle" 
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? "👁️" : "👁️‍🗨️"}
                    </span>
                  </div>
                </div>
                <div className="form-group">
                  <label>First Name *</label>
                  <input name="name" placeholder="First Name" value={editForm.name} onChange={handleEditChange} />
                </div>
                <div className="form-group">
                  <label>Last Name *</label>
                  <input name="lastName" placeholder="Last Name" value={editForm.lastName} onChange={handleEditChange} />
                </div>
                {role === "superadmin" && (
                  <div className="form-group">
                    <label>Phone Number *</label>
                    <input name="MobileNumber" placeholder="Phone Number" value={editForm.MobileNumber} onChange={handleEditChange} />
                  </div>
                )}
                <div className="form-group">
                  <label>Email ID</label>
                  <input name="EmailId" placeholder="Email Id" value={editForm.EmailId} onChange={handleEditChange} />
                </div>
                <div className="form-group">
                  <label>Address</label>
                  <input name="address" placeholder="Address" value={editForm.address} onChange={handleEditChange} />
                </div>
                <div className="form-group">
                  <label>Remarks</label>
                  <input name="remarks" placeholder="Remarks" value={editForm.remarks} onChange={handleEditChange} />
                </div>
                <div className="form-group">
                  <label>Operator Details</label>
                  {role !== "operator" ? (
                    <select
                      name="operatorId"
                      value={editForm.operatorId}
                      onChange={(e) => {
                        const selectedId = Number(e.target.value);
                        const allOptions =
                          role === "admin"
                            ? [
                                {
                                  id: Number(user.operatorId),
                                  operatorName: user.operatorName,
                                  phoneNumber: user.operatorPhoneNumber
                                },
                                ...operators
                              ]
                            : operators;
        
                        const selectedOp = allOptions.find(op => op.id === selectedId);
        
                        setEditForm({
                          ...editForm,
                          operatorId: selectedId,
                          operatorDetails: selectedOp
                            ? `${selectedOp.operatorName} - ${selectedOp.phoneNumber}`
                            : '',
                        });
                      }}
                    >
                      <option value="">-- Select Operator/Admin --</option>
                      {role === "admin" && (
                        <option
                          key={`admin-${user.operatorId}`}
                          value={user.operatorId}
                        >
                          {user.operatorName} - {user.phoneNumber}
                        </option>
                      )}
                      {operators.map(o => (
                        <option key={o.id} value={o.id}>
                          {o.operatorName} - {o.phoneNumber}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      name="operatorDetails"
                      placeholder="Operator Details"
                      value={`${user.operatorName || ''} - ${user.phoneNumber || ''}`}
                      readOnly
                    />
                  )}
                </div>
                {role === "superadmin" && (
                  <div className="form-group">
                    <label>Expiry Date</label>
                    <input
                      type="date"
                      id="ExpiryDate"
                      name="ExpiryDate"
                      value={editForm.ExpiryDate}
                      onChange={handleEditChange}
                      required
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Autoplay</label>
                  <select name="autoplay" value={editForm.autoplay} onChange={handleEditChange}>
                    <option value="on">Autoplay On</option>
                    <option value="off">Autoplay Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button disabled={loading} className="btn btn-primary" onClick={submitEditForm}>
                {loading ? "Updating..." : "Update Customer"}
              </button>
              <button className="btn btn-secondary" onClick={() => setShowEditForm(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};


function DevicesModal({ 
  user, 
  devices, 
  deviceType, 
  assignLoading, 
  onClose, 
  removeDevice, 
  handleResetDevicesCount, 
  fetchAssignableStelfiber,
  assignDevices,
  showAssign,
  setShowAssign,
  assignSearch,
  setAssignSearch,
  assignStelfiberDevice,
  assignDevicesLoading
}) {
  if (!user) return null;

  return (
    <>
      <div className="devices-modal-overlay">
        <div className="devices-modal-container">
          <div className="devices-modal-header">
            <div className="devices-modal-title-section">
              <h2 className="devices-modal-title">Device Management</h2>
              <span className={`devices-modal-type-badge ${deviceType}`}>
                {deviceType === "stelfiber" ? "Stel Fiber" : "Standard Devices"}
              </span>
            </div>
            <button className="devices-modal-close" onClick={onClose}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>

          <div className="devices-modal-body">
            <div className="devices-user-info">
              <div className="devices-user-details">
                <h3 className="devices-user-name">{user.name || user.username}</h3>
                <p className="devices-user-username">@{user.username}</p>
              </div>
            </div>

            {deviceType === "stelfiber" && (
              <button 
                className="devices-assign-btn" 
                disabled={assignLoading} 
                onClick={fetchAssignableStelfiber}
              >
                {assignLoading ? (
                  <>
                    <span className="devices-spinner-small"></span>
                    Loading...
                  </>
                ) : (
                  <>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 4V16M4 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    Assign New Device
                  </>
                )}
              </button>
            )}

            <div className="devices-table-wrapper">
              <table className="devices-table">
                <thead>
                  <tr>
                    <th>Device Name</th>
                    <th>Added Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {devices.length > 0 ? (
                    devices.map(d => (
                      <tr key={d.id} className="devices-table-row">
                        <td className="devices-device-name">
                          <div className="devices-device-info">
                            <div className="devices-device-icon">
                              {deviceType === "stelfiber" ? "📡" : "📱"}
                            </div>
                            <span>{d.name || d.device_name || 'Unknown Device'}</span>
                          </div>
                        </td>
                        <td className="devices-device-date">
                          {d.createdAt || d.added_date || 'N/A'}
                        </td>
                        <td className="devices-device-action">
                          <button
                            className="devices-remove-btn"
                            onClick={() => removeDevice(user.id, d.id)}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="devices-empty-state">
                        <div className="devices-empty-content">
                          <div className="devices-empty-icon">📭</div>
                          <p className="devices-empty-text">No devices found</p>
                          {handleResetDevicesCount && (
                            <button
                              className="devices-reset-btn"
                              onClick={() => handleResetDevicesCount(user.id)}
                            >
                              Reset Device Count
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {devices.length > 0 && (
              <div className="devices-footer">
                <div className="devices-stats">
                  <span className="devices-stats-label">Total Devices:</span>
                  <span className="devices-stats-count">{devices.length}</span>
                </div>
                {handleResetDevicesCount && (
                  <button
                    className="devices-reset-count-btn"
                    onClick={() => handleResetDevicesCount(user.id)}
                  >
                    Reset Count
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Assign Device Modal */}
      {showAssign && (
        <div className="assign-device-modal-overlay">
          <div className="assign-device-modal-container">
            <div className="assign-device-modal-header">
              <h3 className="assign-device-modal-title">Assign Stel Fiber Device</h3>
              <button 
                className="assign-device-modal-close" 
                onClick={() => setShowAssign(false)}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
            
            <div className="assign-device-modal-body">
              <div className="assign-device-search-wrapper">
                <input
                  autoFocus
                  className="assign-device-search"
                  placeholder="Search by device name or MAC address..."
                  value={assignSearch}
                  onChange={(e) => setAssignSearch(e.target.value)}
                />
                <div className="assign-device-search-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
              </div>
              
              <div className="assign-device-list">
                {assignDevices && assignDevices.length > 0 ? (
                  assignDevices
                    .filter(d =>
                      `${d.device_name} ${d.device_mac}`
                        .toLowerCase()
                        .includes(assignSearch.toLowerCase())
                    ).length > 0 ? (
                      assignDevices
                        .filter(d =>
                          `${d.device_name} ${d.device_mac}`
                            .toLowerCase()
                            .includes(assignSearch.toLowerCase())
                        )
                        .map(d => (
                          <div key={d.id} className="assign-device-item">
                            <div className="assign-device-info">
                              <div className="assign-device-icon">📡</div>
                              <div className="assign-device-details">
                                <div className="assign-device-name">
                                  {d.device_name || 'Unnamed Device'}
                                </div>
                                <div className="assign-device-mac">
                                  {d.device_mac}
                                </div>
                              </div>
                            </div>
                            <button
                              className="assign-device-submit-btn"
                              disabled={assignDevicesLoading}
                              onClick={() => assignStelfiberDevice(d.id)}
                            >
                              {assignDevicesLoading ? "Assigning..." : "Assign"}
                            </button>
                          </div>
                        ))
                    ) : (
                      <div className="assign-device-empty">
                        <div className="assign-device-empty-icon">🔍</div>
                        <p>No devices match your search</p>
                      </div>
                    )
                ) : (
                  <div className="assign-device-empty">
                    <div className="assign-device-empty-icon">📡</div>
                    <p>No available devices found</p>
                  </div>
                )}
              </div>
            </div>
            
            <div className="assign-device-modal-footer">
              <button 
                className="assign-device-cancel-btn"
                onClick={() => setShowAssign(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}


export default CustomerV2;